import { Box, Button, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Trans } from 'react-i18next';

import Logo, {
  LogoContainerResponsive,
  LogoFinished,
} from '@/components/Icon/Logo';
import { FullPageLoaderOverlay } from '@/components/Layout/FullPageLoader';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';
import {
  ContentContainer,
  ResponsiveMarginTopMessage,
} from '@/components/Layout/Page/Page.styled';

import { useICBChecking } from '@/hooks/useICBChecking';
import { useTranslate } from '@/hooks/useTranslate';

export function ICBCheckingPage() {
  const { isLoading, onGoBanking } = useICBChecking();
  const { t, language } = useTranslate();

  if (isLoading) {
    return (
      <FullPageLoaderOverlay
        bgColor={(theme: Theme) => theme.palette.background.paper}
      />
    );
  }

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: <LogoFinished />,
      }}
    >
      <ContentContainer>
        <LogoContainerResponsive>
          <Logo />
        </LogoContainerResponsive>
        <ResponsiveMarginTopMessage>
          {t('createNewAccount.icbChecking.header')}
        </ResponsiveMarginTopMessage>
        <Typography variant="body1">
          <Trans
            lang={language}
            i18nKey={t('createNewAccount.icbChecking.body')}
            components={{ b: <b />, i: <i /> }}
          />
        </Typography>
      </ContentContainer>
      <Box width="100%">
        <Form>
          <Button color="primary" onClick={onGoBanking}>
            {t('createNewAccount.icbChecking.button.goToBanking')}
          </Button>
        </Form>
      </Box>
    </Page>
  );
}
